import { useEffect, useState } from "react";
import { Plus, MessageSquare, Trash2, History } from "lucide-react";
import { api, fmtNum } from "@/lib/api";
import { useSchema } from "@/context/SchemaContext";
import ChatPanel from "@/components/chat/ChatPanel";
import { Icon } from "@/lib/icons";
import { Link } from "react-router-dom";

const PROMPTS = [
  "سجّل لي نطاق aql4.store عبر Cloudflare واربطه بخادم Hetzner جديد في فرانكفورت",
  "ابنِ لي وكيلاً ذكياً لخدمة العملاء بالعربية ودرّبه على منتجات متجري",
  "اكتب منشوراً إعلانياً لمنتج جديد وجدوله على تيك توك وإنستغرام الساعة 8 مساءً",
  "ولّد عقد بيع لمصنع إدارة المطاعم بسعر 45,000 ريال للمشتري شركة الأفق",
  "افحص حالة مفاتيح التكاملات وأعطني ملخص كل المصانع",
  "احسب تكلفة تشغيل الخوادم لسنة كاملة مع زيادة 15%",
];

export default function AgentHome() {
  const { factories } = useSchema();
  const [convs, setConvs] = useState([]);
  const [current, setCurrent] = useState(null);
  const [stats, setStats] = useState(null);

  const load = () => api.get("/agent/conversations", { params: { scope: "main" } }).then((r) => setConvs(r.data)).catch(() => {});
  useEffect(() => { load(); api.get("/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  const remove = async (id) => { await api.delete(`/agent/conversations/${id}`); if (current === id) setCurrent(null); load(); };
  const list = Object.values(factories).filter((f) => f.id !== "main");

  return (
    <div className="h-full flex" data-testid="agent-home">
      <div className="flex-1 min-w-0 flex flex-col">
        <div className="px-4 sm:px-6 pt-5 grid grid-cols-2 sm:grid-cols-5 gap-2 fade-up">
          {list.map((f, i) => (
            <Link key={f.id} to={`/factory/${f.id}`} data-testid={`home-factory-chip-${i + 1}`}
              className="group rounded-xl border px-3 py-2.5 flex items-center gap-2 bg-white/[0.02] hover:bg-white/[0.05] transition-colors" style={{ borderColor: `${f.color}26` }}>
              <span className="h-7 w-7 rounded-lg grid place-items-center" style={{ color: f.color, background: `${f.color}14` }}><Icon name={f.icon} size={14} /></span>
              <span className="min-w-0">
                <span className="block text-xs text-slate-200 truncate">{f.short}</span>
                <span className="block text-[11px] font-mono text-slate-500">{stats ? fmtNum(stats.factories?.[f.id]?.total) : "…"} عنصر</span>
              </span>
            </Link>
          ))}
        </div>
        <div className="flex-1 min-h-0">
          <ChatPanel scope="main" color="#00F0FF" conversationId={current} prompts={PROMPTS}
            onConversation={(id) => { setCurrent(id); load(); }} />
        </div>
      </div>

      <aside className="hidden xl:flex w-72 shrink-0 flex-col border-r border-white/[0.06] bg-[#090D16]/60" data-testid="conversations-panel">
        <div className="h-14 flex items-center justify-between px-4 border-b border-white/[0.06]">
          <p className="text-sm font-semibold text-slate-200 flex items-center gap-2"><History size={15} /> المحادثات</p>
          <button data-testid="new-conversation-button" onClick={() => setCurrent(null)} className="h-8 w-8 grid place-items-center rounded-lg bg-white/5 hover:bg-white/10 text-slate-200"><Plus size={16} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-2 space-y-1">
          {convs.length === 0 && <p className="text-xs text-slate-500 text-center py-6">لا محادثات بعد</p>}
          {convs.map((c) => (
            <div key={c.id} className={`group flex items-center gap-2 rounded-xl px-3 py-2 cursor-pointer transition-colors ${current === c.id ? "bg-white/[0.07]" : "hover:bg-white/[0.04]"}`}
              onClick={() => setCurrent(c.id)} data-testid={`conversation-item-${c.id}`}>
              <MessageSquare size={14} className="text-slate-500 shrink-0" />
              <span className="flex-1 text-xs text-slate-200 truncate">{c.title}</span>
              <button onClick={(e) => { e.stopPropagation(); remove(c.id); }} className="opacity-0 group-hover:opacity-100 text-slate-500 hover:text-red-400"><Trash2 size={13} /></button>
            </div>
          ))}
        </div>
        {stats && (
          <div className="p-3 border-t border-white/[0.06] space-y-2" data-testid="home-recent-activity">
            <p className="text-[11px] font-mono uppercase tracking-wider text-slate-500 px-1">آخر النشاط</p>
            {stats.recent.slice(0, 5).map((a) => (
              <div key={a.id} className="text-xs text-slate-400 flex gap-2 px-1">
                <span className="h-1.5 w-1.5 mt-1.5 rounded-full shrink-0" style={{ background: factories[a.factory]?.color || "#94a3b8" }} />
                <span className="truncate">{a.summary}</span>
              </div>
            ))}
          </div>
        )}
      </aside>
    </div>
  );
}
